import React from 'react';
import {useFocusEffect, useRoute} from '@react-navigation/native';
import {getUrlParams} from '@/utils';
import {useSportsIframeStore} from './gr8.store';

const Gr8 = () => {
  const route = useRoute();
  const routePath = (route.params as {path?: string} | undefined)?.path;

  useFocusEffect(
    React.useCallback(() => {
      useSportsIframeStore.getState().show(routePath || getUrlParams().path);
      return () => useSportsIframeStore.getState().hide();
    }, [routePath]),
  );

  return <div className="h-full w-full bg-[#f5f5f5]" />;
};

export default Gr8;
